<template>
    <fieldset>
        <txt label="Api Key" v-model="model.config.apiKey"></txt>
        <txt label="Password" v-model="model.config.password"></txt>

        <input type="checkbox" value="true" v-model="model.config.testMode" /> <label>Test Mode</label>
        <br>
        <input type="checkbox" value="true" v-model="model.status" /> <label>Enabled</label>


        <div class="form-group">
            <label class="control-label">Sort Order</label>
            <input class="form-control" type="text" value="true" v-model="model.sort" />
        </div>

        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
        </div>
</fieldset>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        data: function() {
            return {
                model: {
                    type: 'Eway_Rapid',
                    gateway_type: 1,
                    public_id: 0,
                    status: true,
                    sort: 0,
                    config: {
                        apiKey: "",
                        password: "",
                        testMode: false,
                    }
                }
            }
        },
        created() {
            this.$eventHub.$on('gatewaySubmit', this.store);
            this.$eventHub.$on('setPaymentGateways', this.setData);
        },
        methods: {
            store() {
                this.$store('/api/payment-gateways/store', this);
            },
            setData(data) {
                if (data.gateway_id !== this.model.type) return;
                this.model = this.$setData(data, this.model);
                this.model.type = data.gateway_id;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('productSubmit', this.store);
            this.$eventHub.$off('setPaymentGateways', this.setData);
        },
        components: {
            'txt': require('../../../components/form/text.vue').default
        }
    }
</script>